// Ported from vlookup-dramatic/app/find-a-mentor/page.tsx by scripts/revamp/port-design.js
// Route: /mentors (src/Route/route.js -> RoutesRevamp). Also serves the design's
// /find-a-mentor address through src/revamp/lib/routes.js.
import React from "react";
import { usePageMeta } from "../../hooks/use-page-meta";
import { MentorsBrowser } from "./mentors-browser";

export default function MentorsPage() {
  // Same title/description the old /mentors page set (keeps the SEO the plan
  // wants preserved — task 25 may revise them).
  usePageMeta({
    title: "vLookUp | Creating impactful connections for women mentees",
    description:
      "vLookUp mentors are inspiring and empowering role models, have deep passion for growing talent and believe in fostering diversity.",
  });
  return <MentorsBrowser />;
}
